import locales from '../localization/translations/locales';
import store from 'src/configure-store';

if (!String.format) {
    String.format = function(format) {
      var args = Array.prototype.slice.call(arguments, 1);
      return format.replace(/{(\d+)}/g, function(match, number) { 
        return typeof args[number] != 'undefined'
          ? args[number] 
          : match
        ;
      });
    };
}

export default function translate(key, ...params) {
    const state = store.getState();
    const locale = state.culture && state.culture.locale;
    // Fall back to a known dictionary if the current locale is missing/unknown,
    // so a bad locale can never throw and break module/component loading.
    const dictionary = locales[locale] || locales.uk || locales.en;
    let resource = dictionary[key];
    if(params && params.length > 0){
        resource = String.format(resource, params);
    }
    return resource;
}